import { InputAdornment, MenuItem, Stack, TextField } from "@mui/material";
import React, { useEffect } from "react";
import SearchBoldIcon from "../../ui/Icons/SearchBoldIcon";
import styles from "../../styles/pages/editors.module.scss";
import CustomSelectTwo from "../CustomSelectTwo/CustomSelectTwo";

// interface StatusProps {
//     getStatusSearchData?: any;
//     empty?: any;
//     getStatusData: (newStatus: string) => void;
//     getSearchData: (newSearch: string) => void;
// }

const StatusSearch = (props) => {
  const [status, setStatus] = React.useState("");
  const [search, setSearch] = React.useState("");

  const searchChange1 = (event) => {
    setStatus(event.target.value);
    props?.getStatusData(event.target.value);
  };
  const searchChange2 = (event) => {
    setSearch(event.target.value);
    props?.getSearchData(event.target.value);
  };
  console.warn(status, "status");
  console.warn(search, "search2");
  // status!==""? getStatusSearchData({status:status, search:search}):"";
  // search!==""?getStatusSearchData({status:status, search:search}):""
  // useEffect(()=>{
  //     setStatus(props.goToChild)
  // },[props.goToChild])
  return (
    <>
      <Stack
        direction={"row"}
        alignItems={"center"}
        flexWrap={"wrap"}
        justifyContent={"space-between"}
        className={styles.formcontrolSearch}
      >
        <TextField
          label=""
          id="outlined-size-normal"
          placeholder="Search..."
          onChange={searchChange2}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchBoldIcon />
              </InputAdornment>
            ),
          }}
        />
        <CustomSelectTwo
          value={status}
          onChange={searchChange1}
          // onClick={() => props.empty()}
          displayEmpty
        >
          <MenuItem value={""}>All Status</MenuItem>
          <MenuItem value={1}>Active</MenuItem>
          <MenuItem value={0}>Inactive</MenuItem>
          {/* <MenuItem value={""}>All Status</MenuItem> */}
        </CustomSelectTwo>
      </Stack>
    </>
  );
};

export default StatusSearch;
